import { entityArrayToMap } from '../../../../services/software/software-data-transformer.tsx';
import { WORK_DATA_SET } from '../../../actions/work/index.tsx';
import type { Action } from '../../../types.tsx';
import type { RequestTypesState } from './types.tsx';

export const requestTypesReducer = (
	state: RequestTypesState = {},
	action: Action,
): RequestTypesState => {
	if (action.type === WORK_DATA_SET) {
		const {
			payload: { requestTypes },
		} = action;

		return entityArrayToMap(requestTypes);
	}

	return state;
};
